import {
  ProfileValueOption,
  ProfileFields,
  StoryDocument,
} from '@backrs_ui/grow-ui/src/redux/profile/profile';

import { ResolverFunction } from './resolvers.config';
import { FieldConfig, ProfilePageConfig } from '../types/profile.types';
import { createFieldConfig, DOCUMENT_CONFIGS } from '../utils/fields.helpers';

export const DOCUMENTS_FIELD_CONFIGS: Partial<FieldConfig> = {
  documentsResumes: createFieldConfig({
    key: 'documentsResumes',
    type: { variant: 'DOCUMENT', fileUploadConfig: DOCUMENT_CONFIGS.resume },
  }),
  documentsTranscripts: createFieldConfig({
    key: 'documentsTranscripts',
    type: { variant: 'DOCUMENT', fileUploadConfig: DOCUMENT_CONFIGS.transcript },
  }),
  documentsPersonalAssessment: createFieldConfig({
    key: 'documentsPersonalAssessment',
    type: { variant: 'DOCUMENT', fileUploadConfig: DOCUMENT_CONFIGS.personalAssessment },
  }),
  documentsOther: createFieldConfig({
    key: 'documentsOther',
    type: { variant: 'DOCUMENT', fileUploadConfig: DOCUMENT_CONFIGS.other },
  }),
};

export const DOCUMENTS_PAGE_CONFIG: ProfilePageConfig = {
  title: 'Documents',
  description: 'Add resumes, transcripts, portfolios, and other useful files.',
  sections: [
    {
      title: 'Resumes',
      description: 'Share a few snippets of your work.',
      keys: ['documentsResumes'],
    },
    {
      title: 'Transcripts',
      description:
        "Share your academic history. If you don't have a transcript, you can also upload a report card.",
      keys: ['documentsTranscripts'],
    },
    {
      title: 'Personal Assessments',
      description:
        'Share your aptitude, personality, strengths, skills, and/or career assessments (e.g., YouScience, MBTI, StrengthsFinder, etc.)',
      keys: ['documentsPersonalAssessment'],
    },
    {
      title: 'Other',
      description: 'Share any other documents here.',
      keys: ['documentsOther'],
    },
  ],
};

export const DOCUMENTS_HELPERS: Partial<
  Record<ProfileFields, ResolverFunction<string | number | ProfileValueOption | StoryDocument>>
> = {
  documentsResumes: (profile) => profile.profile.documentsResumes || [],
  documentsTranscripts: (profile) => profile.profile.documentsTranscripts || [],
  documentsPersonalAssessment: (profile) => profile.profile.documentsPersonalAssessment || [],
  documentsOther: (profile) => profile.profile.documentsOther || [],
};
